import { useContext, useState } from 'react';
import "./loginSignup.css";
import { ToastContainer, toast, Bounce } from 'react-toastify';
import { basePath } from '../Constants/constant';
import axios from 'axios';
import { AppContext } from '../ContextApi/ContextApi';
import LazyImage from '../Usables/LazyImage';
import Footer from '../Usables/Footer';

function Login(props) {
    const { setToken } = useContext(AppContext);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({ username: "", password: "", });

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        let data = {
            username_login: formData?.username,
            password_login: formData?.password
        }
        // console.log(data);
        let options = {
            url: `${basePath}/login`,
            method: "POST",
            headers: {
                Accept: "application/json",
            },
            data: data,
        }
        axios(options)
            .then((responce) => {
                // console.log(responce);
                if (responce.status === 200) {
                    localStorage.setItem("name", responce.data.name);
                    localStorage.setItem("userId", responce.data.id);
                    localStorage.setItem("token",responce.data.token);
                    localStorage.setItem("role", responce?.data?.permissions[0].Role.role_name);
                    setToken(responce.data.token);
                    setFormData({username: "", password: "",});
                    setLoading(false)
                    toast.success("Login Successfully");
                    const now = Date.now();
                    localStorage.setItem('lastActive_ats', now);
                    sessionStorage.setItem('session_active_ats', 'true');
                    window.location.href = '/';
                }
                else {
                    setLoading(false);
                    toast.error("Unable to login");
                }
            })
            .catch((e) => {
                setLoading(false);
                console.log(e);
                toast.info(e.response?.data?.error);
            });
    }
    const checkField = () => {
        if (!formData?.username && !formData?.password) {
            toast.error("Username and password required");
        } else if (!formData?.username) {
            toast.error("Username is required");
        } else if (!formData?.password) {
            toast.error("Password is required");
        }
    }

    return (
        <section onClick={() => { }} className=' lightBabyGreen relative w-full min-h-screen'>
            <div className=' w-full h-[92dvh] flex items-center justify-center'>
                <div className=' grid grid-cols-2 lg:w-1/2 rounded-xl overflow-hidden grayBlurShadow'>
                    <div className=' bg-lime-100 flex-1'>
                        <LazyImage className=' m-auto w-[70%]' src="/img/ats_login_img.png" alt="login" />
                    </div>
                    <div className=' flex-1 flex items-center bg-white p-5'>
                        <div className='relative p-7  rounded-xl w-full'>
                            <img className=' w-36 m-auto' src="/img/tcoLogo4.png" alt="" />
                            <h1 className=' font-semibold text-xl text-blue-950 mb-5'>Login to your account</h1>
                            {/* <h1 className=' bg-white absolute top-15px font-semibold px-1 textDarkBlue '>Login</h1> */}
                            <form id='login' onSubmit={handleSubmit} className=' flex flex-col gap-5 '>
                                <div className='input-group relative w-full '>
                                    <input value={formData?.username} onChange={(e) => { setFormData({ ...formData, username: e.target.value }) }} id='username' placeholder='Username' className=' w-full' required type="text" />
                                    <label htmlFor="username" className='label'>Username</label>
                                </div>
                                <div className='input-group relative w-full '>
                                    <input value={formData?.password} onChange={(e) => { setFormData({ ...formData, password: e.target.value }) }} autoComplete='off' id='password' placeholder='Password' className=' w-full' required type="password" />
                                    <label htmlFor="password" className='label'>Password</label>
                                </div>
                                <div>
                                    <button onClick={checkField} type='submit' className=' w-fit darkPurple text-white font-semibold rounded-xl px-7 text-sm py-2 hoverGreen'>{!loading? "Login" : "Loading..." }</button>
                                </div>
                            </form>
                        </div>

                    </div>
                </div>
            </div>
            <Footer/>
        </section>
    );
}

export default Login;